export class BannerConstant {
    static TARGETING_PARAMETER = 't';
    static RECOMMENDED_TARGETING_PARAMETER = 'tr';
    static USER_AGE = 'a';
    static USER_GENDER = 'g';
    static PERSONAL_DATA_KEY = 'v';
    static UNIQUE_ID_KEY = 'u';
    static POSITION_KEY = 'p';
    static IN_LAYER = 'layer';
    /** передавать ли последние использованные приложения пользователя? */
    static WITH_LAST_APPS = 'la';

    static PERSONAL_DATA_ID_KEY = 'i';
    static PERSONAL_DATA_NAME_KEY = 'n';
    static PERSONAL_DATA_BIRTH_DAY_KEY = 'd';
    static PERSONAL_DATA_BIRTH_MONTH_KEY = 'm';
    static PERSONAL_DATA_DAYS_TO_BIRTH_KEY = 'r';
    static PERSONAL_DATA_IS_COMPANYOWNER = 'cow';
    static WITH_UNIQUE_ID = 'wu';
    static WITH_PERSONAL_DATA = 'wv';

    static VIEWPORT_HEIGHT = 'h';
    static EXPR = 'test_id';
    static EXPR_4246 = 'rf4246';
    static EXPR_DELAY = 'rfd';
    static VISIBLE = 'visible';
    static SITEZONE_PARAM = '_SITEZONE';
    static WITH_SITE_ZONE_BANNER_PARAM = 'wsz';
    static SITE_ZONE_BANNER_PARAM = 'sz';
    static SITENAME = 'sitename';

    static WITH_DARK_THEME_PARAM = "wdt";
    static IS_DARK_THEME_PARAM_NAME = "isDarkTheme";

    static WITH_FPID_PARAM = "wfpid";
    static FPID_PARAM = "fpid";

    static GROUP_ID_PARAM = 'group';
    static GROUP_NAME_PARAM = 'grname';
    static GROUP_DESCRIPTION_PARAM = 'grdesc';
    static GROUP_AVATAR_URL_PARAM = 'grpic';
    static IS_GROUP_ACTIVE_MEMBER_PARAM = 'ism';

    static ADD_REQUEST_PARAMS = 'addReqParam';
    static AD_WAIT_TIME = 'adWaitTime';
    static LANGUAGE = 'lang';

    // apps
    static APPS_BANNERS_WITH_CUSTOM_TITLE = 'act';
    static APPS_BANNERS_APP_SHORT_NAME = '_STRING';
    static CONTENT_ID = "content_id";

    static ADF_TRANSPORT_PARAM = "adf";
}
